export default {
  aboutUs: 'apothecary Marketplace is a website specializing in selling spices, legumes, nuts, cosmetics, and all kinds of supplements. In addition to many medical tips about public health and how to use spices in ways that ensure better health for a better life.'
}
